import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomainService } from '../../services/domain.service';
import { LicenseService } from '../../services/license.service';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'itpx-redeem-voucher',
    templateUrl: './redeem.component.html',
    styleUrls: ['./redeem.component.css']
})
export class RedeemVoucherComponent implements OnInit {

    private domain: any;
    private model: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private domainService: DomainService,
        private licenseService: LicenseService,
        private authService: AuthService,
        private notificationService: NotificationService
    ) {
        this.model = {};
    }


    ngOnInit() {
        this.domain = this.domainService.getDomain();
    }


    isFormValid() {
        return true;
    }

    redeem() {
        this.licenseService.redeemVoucher(this.model.voucher)
            .subscribe(
            body => this.handleData(body)
            )
    }

    handleData(data: any) {
        this.router.navigate(['app']);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/redeem/redeem.component.ts